"use client";

import React from "react";
import { Popup } from "@akashnetwork/ui/components";
import { ThreeDSecureModal } from "./ThreeDSecureModal";
interface ThreeDSecurePopupProps {
  isOpen: boolean;
  onClose?: () => void;
  onSuccess: () => void;
  onError: (error: string, isDecline?: boolean) => void;
  clientSecret: string;
  paymentIntentId?: string;
  paymentMethodId?: string;
  title?: string;
  description?: string;
  successMessage?: string;
  errorMessage?: string;
}
export const ThreeDSecurePopup: React.FC<ThreeDSecurePopupProps> = ({
  isOpen,
  onClose: _onClose,
  onSuccess,
  onError,
  clientSecret,
  paymentIntentId,
  paymentMethodId,
  title = "Card Authentication",
  description = "Your bank requires additional verification for this transaction.",
  successMessage = "Your card has been verified successfully.",
  errorMessage = "Please try again or use a different payment method."
}) => {
  return <Popup variant="custom" title={title} open={isOpen} enableCloseOnBackdropClick={false} hideCloseButton maxWidth="sm" actions={[]} data-sentry-element="Popup" data-sentry-component="ThreeDSecurePopup" data-sentry-source-file="ThreeDSecurePopup.tsx">
      <ThreeDSecureModal clientSecret={clientSecret} paymentIntentId={paymentIntentId} paymentMethodId={paymentMethodId} onSuccess={onSuccess} onError={onError} title={title} description={description} successMessage={successMessage} errorMessage={errorMessage} hideTitle={true} data-sentry-element="ThreeDSecureModal" data-sentry-source-file="ThreeDSecurePopup.tsx" />
    </Popup>;
};